<script setup>

import ReservationDetail from "../dashboard/ReservationDetail.vue";
import {onMounted, ref} from "vue";
import moment from "moment/moment.js";
import {router} from "@inertiajs/vue3";
import ClientMessageDialog from "../reservations/ClientMessageDialog.vue";
import {useConfirm} from "primevue/useconfirm";

const emit = defineEmits(['close']);
const notificationMessage = ref();
const doSend = ref(false);
const confirm = useConfirm();
const reservation = defineModel();

const changeDialogVisible = ref(false);
const doReservationChange = (newDate, newTimeStart = null, newTimeEnd = null) => {
    if (reservation.value.reservation_forms?.has_changed_email_template) {
        changeDialogVisible.value = true;
        confirm.require({
            group: 'confirmation-dialog',
            accept: () => {
                reservation.value.date = newDate;
                reservation.value.formatted_date = moment(reservation.value.date).format('DD.MM.YYYY');

                router.post(`/app/forms/event/${reservation.value.id}/change`, {
                    date: newDate,
                    timeStart: newTimeStart,
                    timeEnd: newTimeEnd,
                    message: doSend.value ? notificationMessage.value : null,
                })

                doSend.value = false;
                notificationMessage.value = '';
            }
        })
    } else {
        reservation.value.date = newDate;
        reservation.value.formatted_date = moment(reservation.value.date).format('DD.MM.YYYY');

        router.post(`/app/forms/event/${reservation.value.id}/change`, {
            date: newDate,
            timeStart: newTimeStart,
            timeEnd: newTimeEnd,
            message: null,
        })

        doSend.value = false;
        notificationMessage.value = '';
    }
}
</script>

<template>
    <div>
        <ClientMessageDialog v-model="notificationMessage" v-model:do-send="doSend"></ClientMessageDialog>
        <reservation-detail :reservation="reservation" @change-reservation="(new_date, new_time_start, new_time_end) => doReservationChange(new_date, new_time_start, new_time_end)" @close="emit('close')"></reservation-detail>
    </div>
    </template>
